import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=7ddf1854"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=7ddf1854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports